/** Directory cards: companies use entity id; people use Profile.id + User.id. */
export function directoryEntryMatchesPeers(
  entry: {
    id?: string | null;
    userId?: string | null;
    user?: { id?: string | null } | null;
  },
  peerIds: Set<string>
) {
  return [entry.id, entry.userId, entry.user?.id].some(
    (id) => typeof id === "string" && id.length > 0 && peerIds.has(id)
  );
}

type NotificationPartyIds = {
  senderId?: string | null;
  receiverId?: string | null;
  connectionRequest?: {
    senderId?: string | null;
    receiverId?: string | null;
  } | null;
  senderUser?: {
    id?: string | null;
    profiles?: { id?: string | null }[] | null;
  } | null;
  receiverUser?: {
    id?: string | null;
    profiles?: { id?: string | null }[] | null;
  } | null;
  senderExhibitor?: { id?: string | null } | null;
  receiverExhibitor?: { id?: string | null } | null;
  senderSponsor?: { id?: string | null } | null;
  receiverSponsor?: { id?: string | null } | null;
};

/** User + profile + company ids so person-shaped member cards match live events. */
export function connectionNotificationPeerIds(
  notification: NotificationPartyIds
): Array<string | null | undefined> {
  return [
    notification.senderId,
    notification.receiverId,
    notification.connectionRequest?.senderId,
    notification.connectionRequest?.receiverId,
    notification.senderUser?.id,
    notification.receiverUser?.id,
    notification.senderUser?.profiles?.[0]?.id,
    notification.receiverUser?.profiles?.[0]?.id,
    notification.senderExhibitor?.id,
    notification.receiverExhibitor?.id,
    notification.senderSponsor?.id,
    notification.receiverSponsor?.id,
  ];
}
